import type { AnimationItem } from 'lottie-web';
import type * as PIXI from 'pixi.js';
import { LayerType } from './types/lottie';

/**
 * Describes internal lottie-web transform object
 * After playing lottie this object contains precalculated values
 */
type LottieFinalTransform = {
    /**
     * opacity
     */
    o: { v: number };
    /**
     * anchor point
     */
    a: { v: [number, number] };
    /**
     * position
     */
    p: { v: [number, number] };
    /**
     * rotation
     */
    r: { v: number };

    /**
     * scale
     */
    s: { v: [number, number] };
};

export function getLottieFinalTransformForLayer(
    animationItem: AnimationItem,
): LottieFinalTransform {
    return animationItem.renderer.elements[0].finalTransform.mProp;
}

/**
 * Applies lottie transformation to a given container
 */
export function applyLottieTransformToPixiContainer(
    container: PIXI.Container,
    lottieTransform: LottieFinalTransform,
    scaleFactor: number,
) {
    const opacity = lottieTransform.o.v;
    const position = lottieTransform.p.v;
    const rotation = lottieTransform.r.v;
    const anchor = lottieTransform.a.v;
    const scale = lottieTransform.s.v;
    const elementType: LayerType = (lottieTransform as any).elem.data.ty;

    container.position.set(position[0] * scaleFactor, position[1] * scaleFactor);
    container.alpha = opacity;
    container.rotation = rotation;
    container.scale.set(scale[0], scale[1]);

    let pivotX = anchor[0] * scaleFactor;
    let pivotY = anchor[1] * scaleFactor;

    if (elementType === LayerType.Shape) {
        // Lottie shapes rotate and scale around the center of the shape
        pivotX += container.width / 2 / scale[0];
        pivotY += container.width / 2 / scale[1];
    }

    container.pivot.set(pivotX, pivotY);
}

export function resetTransformOfPixiContainer(container: PIXI.Container) {
    container.position.set(0);
    container.alpha = 1;
    container.rotation = 0;
    container.scale.set(1);
    container.pivot.set(0);
}
